function updateButtonText() {
  let button = document.querySelector(
    ".shopify-payment-button__button.shopify-payment-button__button--unbranded"
  );
  if (button && !button.dataset.updated) {
    button.innerHTML = "🛒 Buy with Cash on Delivery"; // Unicode cart icon
    button.dataset.updated = "true"; // Prevent duplicate updates
  }
}

// Run immediately if the button is already on the page
updateButtonText();
